"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _user = require("_a/admin/user/user");
var _message = require("_l/message");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Profile',
  data: function data() {
    var _this = this;
    var validatePassCheck = function validatePassCheck(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入确认密码'));
      } else if (value !== _this.formPass.password) {
        callback(new Error('两次密码不一致，请重新输入'));
      } else {
        callback();
      }
    };
    return {
      activeName: 'first',
      form: {},
      formPass: {},
      rules: {
        nickName: [this.$ruler('昵称')],
        sex: [this.$ruler('性别', 'change')],
        phoneNumber: [this.$ruler('手机号')]
      },
      rulesPass: {
        oldPassword: [this.$ruler('旧密码'), {
          type: 'string',
          max: 16,
          min: 6,
          message: '请输入6-16个字符',
          trigger: 'blur'
        }],
        newPassword: [this.$ruler('新密码'), {
          type: 'string',
          max: 16,
          min: 6,
          message: '请输入6-16个字符',
          trigger: 'blur'
        }],
        passwordCheck: [this.$ruler('确认密码'), {
          validator: validatePassCheck,
          trigger: 'blur'
        }]
      },
      sexOptionList: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['userInfo'])),
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    saveInfo: function saveInfo() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _user.updateInfo)(_this2.form).then(function (res) {
            if (res.data) {
              (0, _message.MessageSuccess)('upd');
            } else {
              (0, _message.MessageError)('upd');
            }
          });
        }
      });
    },
    savePass: function savePass() {
      var _this3 = this;
      this.$refs['formPass'].validate(function (valid) {
        if (valid) {
          (0, _user.updatePass)(_this3.formPass).then(function (res) {
            if (res.data) {
              (0, _message.MessageSuccess)('upd');
            } else {
              (0, _message.MessageError)('upd');
            }
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;
    this.getDictListByType('sex').then(function (res) {
      _this4.sexOptionList = res;
    });
    this.form = _objectSpread({}, this.userInfo);
  }
};